import {Circle1} from "../../Shapes/Section4/Circle1";
import {Circle2} from "../../Shapes/Section4/Circle2";
import {Circle3} from "../../Shapes/Section4/Circle3";
import {Circle4} from "../../Shapes/Section4/Circle4";
import {Dots} from "../../Shapes/Dots/Dots";
import sampleImage4 from "../../../../public/static/photojoiner.com-photo-stitch-sample-4.webp";
import Image from "next/image";
import {isMobile} from "react-device-detect";

export interface IStitchFeatureSection4Props {
  backgroundColor: string;
  imageSrc: string;
  circle1Color?: string;
  circle2Color?: string;
  circle3Color?: string;
  circle4Color?: string;
  dots1Color?: string;
  dots2Color?: string;
}

export const StitchFeatureSection4 = ({
  backgroundColor,
  circle1Color = "transparent",
  circle2Color = "transparent",
  circle3Color = "transparet",
  circle4Color = "transparent",
  dots1Color = "transparent",
  dots2Color = "transparent",
  imageSrc,
}: IStitchFeatureSection4Props) => {
  return (
    <div className="py-24 px-4 lg:px-52" style={{ backgroundColor }}>
      <div className="flex flex-col-reverse lg:flex-row">
        <div className="w-full flex mr-16 justify-center items-center lg:justify-end ">
          <div className="relative my-16">
            <Image
              src={imageSrc}
              className="opacity-0"
              width={1000}
              height={1000}
              alt="Collage Editor Screenshot"
            />
            <div className="absolute inset-0 z-10 flex ">
              <Image
                src={sampleImage4}
                className="shadow-lg"
                alt="Collage Editor Screenshot"
                width={isMobile ? 500 : 1000}
                sizes={`max-width: ${isMobile?500:1000}px`}
              />
            </div>

            <div className="hidden lg:block absolute top-0 right-0 translate-x-1/4 -translate-y-16">
              <Circle1 fill={circle1Color} />
            </div>

            <div className="hidden lg:block absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3">
              <Circle2 fill={circle2Color} />
            </div>

            <div className="hidden lg:block absolute left-0 top-0 -translate-x-1/3 -translate-y-1/3">
              <Circle3 fill={circle3Color} />
            </div>

            <div className="hidden lg:block absolute left-1/2 bottom-0 translate-y-1/4 -translate-x-1/2">
              <Circle4 fill={circle4Color} />
            </div>

            <div className="hidden lg:block absolute left-1/2 top-0  -translate-y-1/2">
              <Dots fill={dots1Color} />
            </div>

            <div className="hidden lg:block absolute right-0 bottom-0 translate-y-1/4 translate-x-1/4">
              <Dots fill={dots2Color} />
            </div>
          </div>
        </div>
        <div className="w-full flex flex-col justify-center items-center gap-4 lg:pl-24">
          <h2 className="text-6xl " style={{ maxWidth: "16ch" }}>
            Add Borders, Text, Stickers, and More
          </h2>
          <div className="leading-relaxed" style={{ maxWidth: "45ch" }}>
            This Photo Joiner tool can do more than just merge photos! You can
            add styled borders, backgrounds, stickers, doodles, and even text.
            You can also adjust the border size and radius to make that perfect
            panorama. Perfect for those before and after photos with text.
          </div>
        </div>
      </div>
    </div>
  );
};
